module.exports = __webpack_public_path__ + "img/banner1.ca02b2a7.png";